module.exports = __webpack_public_path__ + "img/lens-174-minus-05.129244a2.png";